import React from "react";

const SelectBox = (props) => {
  // Pull out props that are not valid DOM attributes on <select> so they are not
  // leaked onto the element (React warns otherwise). readOnly is not honoured by a
  // native <select>, so map it (and disabled) to the real `disabled` attribute.
  const { items, placeholder, minwidth, readOnly, disabled, onChange, ...rest } = props;

  return (
    <select
      {...rest}
      disabled={disabled || readOnly || undefined}
      onChange={(ev) => {
        if (onChange) {
          onChange(ev.target.value, ev);
        }
      }}
    >
      {items && items.length
        ? items.map((item, index) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))
        : null}
    </select>
  );
};

export default SelectBox;
